import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";

const parentBreadCrumbs = [
  { title: "menu_sidebar_management" },
  { title: "menu_sidebar_management_list_management" },
  { title: "menu_sidebar_management_list_management_make" }
];

const MakeListing = Loadable({
  loader: () => import("container/management/auto/make"),
  loading() {
    return <Loader />;
  }
});

export const makeRoutes: IRoute[] = [
  {
    path: "/management/make",
    element: <MakeListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
